import {
  IReplenishmentData,
  IReplenishmentEditQuantity,
  IReplenishmentMigrateSkuData,
  IReplenishmentSkuMoved,
} from "interfaces/IReplenishment"
import { api as apiService, ApiService } from "./api"
import { IParamsPagination } from "shared/TableCustom/types"
import { IPaginationResponse } from "interfaces/IPagination"

class ReplenishmentService {
  constructor(private readonly api: ApiService) {}

  public getNewReplenishment = async () => {
    return await this.api.get(
      process.env.REACT_APP_TORANJA_API + "/replenishments/new-replenishments-request",
    )
  }

  public getNewReplenishmentVerify = async () => {
    return await this.api.get(
      process.env.REACT_APP_TORANJA_API + "/replenishments/new-replenishments-request/verify",
    )
  }

  public getReplenishments = async (
    params: IParamsPagination,
  ): Promise<IPaginationResponse<object>> => {
    return await this.api.get(toranjaURL + `/replenishments/`, {
      params,
    })
  }

  public createReplenishment = async (data: IReplenishmentData) => {
    return await this.api.post(toranjaURL + "/replenishments/", data)
  }

  public confirmSkuMove = async (productId: number | undefined, data: IReplenishmentSkuMoved) => {
    return await this.api.put(toranjaURL + `/replenishments/sku/${productId}/move`, data)
  }

  public editReplenishmentQuantity = async (id: number, data: IReplenishmentEditQuantity) => {
    return await this.api.patch(toranjaURL + `/replenishments/${id}`, data)
  }

  public deleteReplenishment = async (id: number) => {
    return await this.api.delete(toranjaURL + `/replenishments/${id}`)
  }

  public migrateSkuReplenishment = async (data: IReplenishmentMigrateSkuData) => {
    return await this.api.post(toranjaURL + "/replenishments/sku/migrate", data)
  }
}
const toranjaURL = process.env.REACT_APP_TORANJA_API
export const replenishmentService = new ReplenishmentService(apiService)
